'use client';

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, domMax, LazyMotion, m, useReducedMotion } from 'motion/react';
import type { ReactNode } from 'react';
import { DURATION_POSITION_SMALL_MS, EASE_EXIT_MOTION, MOTION_POSITION_SMALL } from '@/lib/ui/easing';
const EXIT_TRANSITION = {
  duration: DURATION_POSITION_SMALL_MS / 1000,
  ease: EASE_EXIT_MOTION
} as const;
export function PortfolioListTransition(t0) {
  const $ = _c(16);
  const {
    view,
    children
  } = t0;
  const reducedMotion = useReducedMotion() === true;
  let t1;
  if ($[0] !== reducedMotion) {
    t1 = reducedMotion ? {
      duration: 0
    } : MOTION_POSITION_SMALL;
    $[0] = reducedMotion;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const transition = t1;
  let t2;
  if ($[2] !== reducedMotion) {
    t2 = reducedMotion ? false : {
      opacity: 0,
      y: 8
    };
    $[2] = reducedMotion;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 1,
      y: 0
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== reducedMotion) {
    t4 = reducedMotion ? {
      opacity: 1
    } : {
      opacity: 0,
      y: -6,
      transition: EXIT_TRANSITION
    };
    $[5] = reducedMotion;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children || $[8] !== t2 || $[9] !== t4 || $[10] !== transition || $[11] !== view) {
    t5 = <AnimatePresence mode="wait"><m.div key={view} layout={false} className="flex w-full min-w-0 flex-col" initial={t2} animate={t3} exit={t4} transition={transition}>{children}</m.div></AnimatePresence>;
    $[7] = children;
    $[8] = t2;
    $[9] = t4;
    $[10] = transition;
    $[11] = view;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5 || $[14] !== transition) {
    t6 = <LazyMotion features={domMax}><m.div layout={true} transition={transition} className="min-w-0">{t5}</m.div></LazyMotion>;
    $[13] = t5;
    $[14] = transition;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}